@if (isLoadingFollow) {
    <ion-spinner name="crescent"></ion-spinner>
} @else {
    @if (isViewer()) {
        <div class="clickable-area" (click)="unfollow()" fill="clear">
            <ion-icon color="dark" name="notifications"></ion-icon>
        </div>
    } @else {
        <div class="clickable-area" (click)="follow()" fill="clear">
            <ion-icon slot="icon-only" name="notifications-outline"></ion-icon>
        </div>
    }
}
